import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';

import useGlobalStatus from '../../hook/useGlobalStatus';

import { SpanError } from '../../components/customStyles/form';
import SimpleDatePicker from '../../components/date/SimpleDatePicker';

import { WORK_DATA, WORK_VALIDATE_RULE } from './constants';

import theme from '../../theme';


const CreateWorkModal = (props) => {
  const {
    editMode,
    isLoading,
    inputErrorMsg,
    modalData,
    handleModalSubmit,
    handleClose
  } = props;

  const [workData, setWorkData] = useState(editMode ? modalData : WORK_DATA);

  const handleInput = (e) => {
    const { name, value } = e.target;

    setWorkData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleDateInput = (target, value) => {
    setWorkData(prev => ({
      ...prev,
      [target]: value
    }))
  }

  return (
    <Box
      sx={{
        width: { sx: '300px', md: '400px' },
        textAlign: 'start'
      }}
    >
      <Box mb={3}>
        <Box mb={1}>
          <Typography variant='h5'>廣告帳號<SpanError>*</SpanError></Typography>
        </Box>

        <Box>
          <TextField
            fullWidth
            size="small"
            name="account_id"
            placeholder="請輸入廣告帳號"
            defaultValue={workData.account_id}
            error={inputErrorMsg.account_id ? inputErrorMsg.account_id : false}
            helperText={inputErrorMsg.account_id ? WORK_VALIDATE_RULE.account_id.errorMsg : null}
            FormHelperTextProps={{
              sx: {
                color: theme.palette.error.main,
                textAlign: 'left',
                marginLeft: 0
              }
            }}
            onChange={handleInput}
          />
        </Box>
      </Box>

      <Box mb={3}>
        <Box mb={1}>
          <Typography variant='h5'>資料開始日期<SpanError>*</SpanError></Typography>
        </Box>
        <SimpleDatePicker
          targetField="start_date"
          dateValue={workData.start_date}
          handleDateInput={handleDateInput}
          isError={inputErrorMsg.start_date ? inputErrorMsg.start_date : false}
          errorMsg={WORK_VALIDATE_RULE.start_date.errorMsg}
        />
      </Box>

      <Box mb={3}>
        <Box mb={1}>
          <Typography variant='h5'>資料結束日期<SpanError>*</SpanError></Typography>
        </Box>
        <SimpleDatePicker
          targetField="end_date"
          dateValue={workData.end_date}
          handleDateInput={handleDateInput}
          isError={inputErrorMsg.end_date ? inputErrorMsg.end_date : false}
          errorMsg={WORK_VALIDATE_RULE.end_date.errorMsg}
        />
      </Box>

      <FormHelperText error={inputErrorMsg.check_date ? inputErrorMsg.check_date : false}>{inputErrorMsg.check_date ? WORK_VALIDATE_RULE.start_date.errorMsg_check : null}</FormHelperText>

      <Stack
        variant='center-center'
        sx={{ margin: '32px 0 16px 0' }}
      >
        <>
          <Button
            variant="text-cancel"
            disabled={isLoading}
            onClick={handleClose}
          >
            取消
          </Button>

          <Button
            variant="fill-main"
            disabled={isLoading}
            endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
            onClick={() => handleModalSubmit(workData, 'creatWork')}
            sx={{ color: "#fff" }}
          >
            建立
          </Button>
        </>
      </Stack>

    </Box>
  )
}

export default CreateWorkModal;